import React, { useRef, useState } from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { addNewPromoProduct } from "../../../services/MasterApiServices";
import { useSelector } from "react-redux";
import {
  PromoProductsClass,
  toPromoProductRef,
} from "../../../core/json/PromoProductsClass";
import toast from "react-hot-toast";
import { TaxClass } from "../../../core/json/TaxClass";
const AddPromoProduct = ({ Promotionlist, handlePromoProductList }) => {
  // const [Data, setData] = useState([]);
  const [promoName, setpromoName] = useState();
  // const [section, setsection] = useState();
  // const [productId, setproductId] = useState(1);
  const [isaddActive, setisaddActive] = useState(false);
  const { branch } = useSelector((state) => state.branchlist);
  const { productList, taxList } = useSelector(
    (state) => state.usersetting
  );
  const { userId } = useSelector((state) => state.userauth);
  const { register, handleSubmit, setValue, getValues, control } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "ProductData",
  });
  // const modifiedSection = sectionList?.map((e) => ({
  //   value: e.guid,
  //   label: e.name,
  // }));
  const modifiedPromotion = Promotionlist?.map((e) => ({
    value: e.guid,
    label: e.name,
  }));
  const modifiedProduct = productList?.map((e) => ({
    value: e.guid,
    label: e.name,
  }));

  const handlePromoNameChange = (selectedPromo) => {
    setpromoName(selectedPromo);
    setisaddActive(!!selectedPromo); // Enable Add button if promoName is selected
  };
  
  const handleAddPromo = () => {
    append({ product: "", rate: "" });
  };

  // const handleSection = (e) => {
  //   setsection(e);
  //   append({ product: "", rate: "" });
  //   setisaddActive(true);
  // };

  const handlesubmitPromoProduct = async (formData) => {
    // the promotion picker is a react-select outside react-hook-form - check it
    // here, or promoName.value below throws and Submit silently does nothing
    if (!promoName?.value) {
      toast.error("Promotion name is required.");
      return;
    }
    const rows = formData?.ProductData || [];
    if (!rows.length) {
      toast.error("Add at least one product.");
      return;
    }
    const objtax = new TaxClass();
    const ProductDetail = rows.map((e) => {
      const product = productList?.find((item) => item.guid == e.product?.value);
      return {
        product: toPromoProductRef(product),
        price: Number(e.rate) || 0,
        // the list row carries only taxID; look the tax up, blank when unknown
        tax: taxList?.find((t) => t.guid == product?.taxID) || objtax,
      };
    });
    const objpromoproduct = new PromoProductsClass();
    const promotion = Promotionlist?.find(
      (item) => item.guid == promoName.value
    );
    // GetAll returns promotions with branch: null; fill it in so the server
    // does not dereference a null branch on the nested promotion
    objpromoproduct.promotion = promotion && {
      ...promotion,
      branch: promotion.branch || branch,
    };
    objpromoproduct.branch = branch;
    // Section was dropped from promo products (PromoProductsClass, Apr 2025).
    // The old hard-coded placeholder section (isDeleted: true, guid "string"
    // on its nested branch / company / department) is no longer sent.
    objpromoproduct.promoProductsDetail = ProductDetail;
    objpromoproduct.updatedUser = `{${userId?.id}}`;
    objpromoproduct.createdUser = `{${userId?.id}}`;
    try {
      const response = await addNewPromoProduct(objpromoproduct);
      if (response?.data === false) {
        toast.error("Failed to add promo product.");
        return;
      }
      handlePromoProductList();
      closemodal();
      remove(); // clear every row (removing index by index skipped rows)
      setpromoName(null);
      setisaddActive(false);
      toast.success("Promo product added successfully!");
    } catch (error) {
      toast.error(
        error?.response?.data?.Message ||
          error?.response?.data?.title ||
          "Failed to add promo product."
      );
      console.error(error);
    }
  };
  // without this, a row missing its product or rate made Submit do nothing
  const handleInvalidPromoProduct = () => {
    toast.error("Choose a product and enter a rate on every row.");
  };
  const closeButtonRef = useRef();

  const closemodal = () => {
    if (closeButtonRef.current) {
      closeButtonRef.current.click();
    }
  };
  return (
    <div>
      <div className="modal fade" id="add-promo-product">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Add Promo Products</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    ref={closeButtonRef}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form
                    onSubmit={handleSubmit(
                      handlesubmitPromoProduct,
                      handleInvalidPromoProduct
                    )}
                  >
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="input-blocks">
                          <label>
                            Promotion name<span className="text-danger">*</span>
                          </label>

                          <Select
                            options={modifiedPromotion}
                            classNamePrefix="react-select"
                            value={promoName}
                            onChange={handlePromoNameChange}
                            placeholder="Choose Promotion"
                            required
                          />
                        </div>
                      </div>
                      {/* <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="input-blocks">
                          <label>
                            Section<span className="text-danger">*</span>
                          </label>
                          <Select
                            options={modifiedSection}
                            classNamePrefix="react-select"
                            placeholder="Choose Section"
                            value={section}
                            onChange={handleSection}
                            required
                          />
                        </div>
                      </div> */}
                    </div>

                    <div
                      className="row p-2"
                      style={{
                        maxHeight: "300px",
                        height: "auto",
                        overflow: "scroll",
                        position: "relative",
                      }}
                    >
                      <div className="row">
                        <div className="col-4">
                          Product<span className="text-danger">*</span>
                        </div>
                        <div className="col-4">
                          Rate<span className="text-danger">*</span>
                        </div>
                        <div className="col-4">Action</div>
                      </div>
                      {fields?.map((obj, index) => {
                        return (
                          // keyed by the field id, not the index: with index keys,
                          // deleting a row left the rate boxes showing the wrong
                          // values and submit failed on a row that looked filled
                          <React.Fragment key={obj.id}>
                            <hr />
                            <div className="row">
                              <div className="col-4">
                                <div className="input-blocks">
                                  <Controller
                                    name={`ProductData[${index}].product`}
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                      <Select
                                        {...field}
                                        classNamePrefix="Choose Product"
                                        isClearable={true}
                                        isSearchable={true}
                                        options={modifiedProduct}
                                        styles={{
                                          menu: (provided) => ({
                                            ...provided,
                                            zIndex: 9999,
                                          }),
                                        }}
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                              <div className="col-4">
                                <div className="input-blocks">
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(`ProductData[${index}].rate`, {
                                      required: true,
                                    })}
                                    name={`ProductData[${index}].rate`}
                                  />
                                </div>
                              </div>
                              <div className="col-4 promo-delete">
                                <div className="edit-delete-action">
                                  <Link
                                    className="confirm-text p-2"
                                    to="#"
                                    onClick={() => remove(index)} // Deleting the item at this index
                                  >
                                    <i
                                      data-feather="trash-2"
                                      className="feather-trash-2"
                                    ></i>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                    <button
                      className="btn btn-success mt-4"
                      onClick={handleAddPromo}
                      type="button"
                      disabled={!isaddActive}
                    >
                      Add
                    </button>
                    <div className="col-lg-12">
                      <div className="modal-footer-btn">
                        <button
                          type="button"
                          className="btn btn-cancel me-2"
                          data-bs-dismiss="modal"
                        >
                          Reset
                        </button>
                        <button type="submit" className="btn btn-submit">
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPromoProduct;
